import {Typography} from "@bonprix/design-system";
import React from "react";

export default function SustainabilityIntroduction({text}) {
    if(!text) {
        return <></>;
    }
    return (<div className={"sustainability-introduction"}>
        <Typography variant={"body1"}>{text}</Typography>
    </div>);
}